import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import "./BlogList.css";

const BlogList = () => {
  const [blogs, setBlogs] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("ALL");
  const [loading, setLoading] = useState(true);
  const [visibleBlogs, setVisibleBlogs] = useState(6);

  const categories = [
    "ALL",
    "HEALTH",
    "MEDICINE",
    "LIFESTYLE",
    "WELLNESS",
    "MEDICAL RESEARCH",
    "HEALTHCARE",
  ];

  useEffect(() => {
    fetchBlogs();
  }, []);

  const fetchBlogs = async () => {
    try {
      const response = await axios.get("https://api.swasthmitra.com/api/blogs");
      setBlogs(response.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching blogs:", error);
      setLoading(false);
    }
  };

  const filteredBlogs = blogs.filter((blog) =>
    selectedCategory === "ALL"
      ? true
      : blog.category.toUpperCase() === selectedCategory
  );

  const loadMore = () => {
    setVisibleBlogs((prev) => prev + 6);
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  if (loading) {
    return <div className="loading">Loading blogs...</div>;
  }

  return (
    <>
      <div className="blogListSection">
        <div className="blogListHeaderContainer">
          <div className="blogListHeader">
            <p className="hd">Your nearest Medical Guide & Collection Centre</p>
            <div className="blogListHeaderCategories">
              {categories.map((category) => (
                <motion.p
                  key={category}
                  className={
                    selectedCategory === category ? "activeCategory" : ""
                  }
                  onClick={() => setSelectedCategory(category)}
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                >
                  {category}
                </motion.p>
              ))}
            </div>
          </div>
        </div>
        <div className="blogPostListContainer">
          {filteredBlogs.slice(0, visibleBlogs).map((blog) => (
            <motion.div
              key={blog._id}
              className="blogPost"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              whileHover={{ y: -5 }}
            >
              <div className="blogPostThumb">
                <img src={blog.imageUrl} alt={blog.title} />
              </div>
              <div className="blogPostContent">
                <div className="blogPostContentDate">
                  <p>by {blog.author}</p>
                  <p>{new Date(blog.createdAt).toLocaleDateString()}</p>
                </div>
                <div className="blogPostContentHeading">
                  <Link to={`/blog/${blog._id}`} onClick={scrollToTop}>
                    {blog.title}
                  </Link>
                </div>
                <div className="blogPostContentDescription">
                  <p>{blog.content.substring(0, 150)}...</p>
                </div>
                <div className="blogPostContentReadMore">
                  <Link to={`/blog/${blog._id}`} onClick={scrollToTop}>
                    View Details
                  </Link>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
        {visibleBlogs < filteredBlogs.length && (
          <motion.p
            className="blogListShowMore"
            onClick={loadMore}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            Load More
          </motion.p>
        )}
      </div>
    </>
  );
};

export default BlogList;
